const labelsValidationEN = {
    "name": {
        "required": "Name of label is required",
        "unique": "Oops! This label already exists and is owned by another user. Please try another label name. If you legally own this label name and you own the name copyright, please contact our support team.",
        "available": "Label name is available",
        "invalid": "Label name is invalid",
    },
    "year": {
        "required": "Established year is required",
        "numeric": "The value is not a number",
        "stringLength": "Established year has to be 4 digits long",
    },
    "releaseCatalog": {
        "required": "Releases in catalog is required",
        "numeric": "The value is not a number",
    },
    "logo": {
        "required": "The logo is required",
        "dimensions": "The label logo size has to be 1000 x 1000 px, JPG/JPEG/PNG.",
        "choose": "Please choose an image",
        "file": "Please Upload JPG or PNG formats, minimal resolution 1000x1000px. Max size 2MB"
    },
    "promo_graphic": {
        "dimensions": "The label promotional graphic size has to be 960 x 150 px, JPG/JPEG/PNG.",
        "choose": "Please choose an image",
        "file": "Upload JPG or PNG formats, minimal resolution 960x150px"
    }
};

export default labelsValidationEN;